@if (openNow()) {
  <span
    class="inline-flex items-center rounded-md bg-primary-500 px-2 py-1 text-xs font-bold text-white gap-1.5"
  >
    <svg viewBox="0 -960 960 960" class="fill-white h-4 w-4 m-auto">
      <path
        d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z"
      />
    </svg>

    Open today: {{ listing().openToday!.start | date: 'h:mm a' }} -
    {{ listing().openToday!.end | date: 'h:mm a' }}
  </span>
}

@if (listing().openTomorrow) {
  <span
    class="inline-flex items-center rounded-md bg-villages-feature-flag-500 text-primary-500 px-2 py-1 text-xs font-bold gap-1.5 backdrop-blur-xs"
  >
    <svg viewBox="0 -960 960 960" class="fill-primary-500 h-4 w-4 m-auto">
      <path
        d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z"
      />
    </svg>

    Open tomorrow: {{ listing().openTomorrow!.start | date: 'h:mm a' }} -
    {{ listing().openTomorrow!.end | date: 'h:mm a' }}
  </span>
}
